import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ClaimActionsService } from 'src/app/pages/customer-dashboard/services/claim-actions.service';

@Component({
  selector: 'fury-claim-tab',
  templateUrl: './claim-tab.component.html',
  styleUrls: ['./claim-tab.component.scss']
})
export class ClaimTabComponent implements OnInit {
  @Input() services: any;

  displayedColumns: string[] = [
    'createdAt',
    'agreementNumber',
    'fileClaimNumber',
    'firstName',
    'lastName',
    'phoneNumber',
    'emailAddress',
    'address',
    'city',
    'state',
    'zip',
    'coveredItem',
    'transactionId',
    'cardType',
    'amount',
    'availability',
    'status',
    'actions'
  ];
  dataSource = [];
  selectedTabIndex = 0;
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  searchType = "contains";
  @Input() userId = "";
  @Input() editorAccess:boolean;
  @Input() agreementId = null;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  tabMapping = {
    0: "All",
    1: "Active",
    2: "Unassigned",
    3: "Escalated",
    4: "Pending Parts",
    5: "Pending Decision",
    6: "Closed",
  };
  ngUnsubscribe = new Subject<void>();
  constructor(private apiService: ApiService, private claimActionsService: ClaimActionsService) {}

  ngOnInit(): void {
    this.fetchClaimDetails();
    this.shouldFetchClaims();
  }

  fetchClaimDetails() {
    const agreementId =  this.agreementId? '/'+this.agreementId : '';
    const tabName =
      this.selectedTabIndex === 0 // 0 means all
        ? ""
        : `&tabName=${this.tabMapping[this.selectedTabIndex]}`;
    this.apiService
      .get(
        `${endpoints.customerDashboard.getClaims(this.userId)}${agreementId}?page=${
          this.pageIndex + 1}&size=${this.pageSize}${tabName}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          this.dataSource = res.body?.claims?.data;
          this.totalCount = res.body?.claims?.total;
        },
        () => {
          this.dataSource = [];
          this.totalCount = 0;
        }
      );
  }

  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
    this.pageIndex = 0;
    this.totalCount = 0;
    this.fetchClaimDetails();
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchClaimDetails();
  }
  shouldFetchClaims(){
    this.claimActionsService.shouldCancelFetchClaims$.pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (res) => {
        if(res) this.fetchClaimDetails();
      },
    );
  
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}
